var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5378 19.9112L17 22H19.5L5.49998 2H2.99998L4.77763 4.53951C3.01861 5.38274 2 7.2003 2 9.99219C2 15.9922 9.95452 21.1469 11.5454 21.979H12.4545C12.9725 21.7081 14.1649 20.979 15.5378 19.9112Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.97603C22 12.897 20.1249 15.6148 18.0134 17.7335L8.49909 4.14158C9.16285 4.31023 9.78704 4.61561 10.3285 5.04194C11.1471 5.6865 11.7332 6.49436 12 7.49219C12.2668 6.49436 12.8528 5.6865 13.6714 5.04194C14.4901 4.39739 15.4978 4.02931 16.5454 3.99219C19.9091 3.99219 22 5.99219 22 9.97603Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeFilled);
export default __webpack_public_path__ + "static/media/dislikeFilled.fa3534ec0afed0eb4af1cc9f241fb477.svg";
export { ForwardRef as ReactComponent };